import { useCallback, useState } from 'react';
import type { SearchMode } from '@/entities/search';

export type CommittedSearch = {
  query: string;
  mode: SearchMode;
};

export type UseCommittedSearchResult = {
  committed: CommittedSearch | null;
  commit: (query: string, mode: SearchMode) => void;
  clear: () => void;
};

/**
 * State for "committed" search: query is applied only when user explicitly triggers search.
 * Use for infinite scroll and paginated lists where search doesn't run on every keystroke.
 */
export const useCommittedSearch = (): UseCommittedSearchResult => {
  const [committed, setCommitted] = useState<CommittedSearch | null>(null);

  const commit = useCallback((query: string, mode: SearchMode) => {
    setCommitted(query.trim() ? { query: query.trim(), mode } : null);
  }, []);

  const clear = useCallback(() => {
    setCommitted(null);
  }, []);

  return { committed, commit, clear };
};
